import type { CSSProperties } from "react";
import { C, mono, type } from "../theme.ts";

/**
 * The mono uppercase label that opens a section: "THE HEAVY THING", "NEXT
 * SEVEN DAYS", "DUE", a pantry section name. `micro` is the smaller, tighter
 * variant used for a sub-label inside a column — a day-of-week header, a
 * group-by-area name.
 *
 * Font, size and colour are the token; margin stays the caller's, passed
 * through `style`, because the surfaces this pulls together never agreed on
 * their vertical rhythm and forcing one now would move far more than this
 * session asked for.
 */
export function SectionHeader({
  children, size = "default", tone = "default", style,
}: {
  children: React.ReactNode;
  size?: "default" | "micro";
  tone?: "default" | "flag";
  style?: CSSProperties;
}) {
  const base: CSSProperties = size === "micro"
    ? { fontFamily: mono, fontSize: type.micro, color: C.inkGhost }
    : {
        fontFamily: mono, fontSize: type.small, letterSpacing: 1,
        color: tone === "flag" ? C.flagInk : C.inkFaint,
      };
  return <p style={{ margin: 0, ...base, ...style }}>{children}</p>;
}
